import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import OpportunityWizard from '@/components/opportunity-wizard/OpportunityWizard';

const OpportunityWizardPage = () => {
  return (
    <Routes>
      <Route path="/*" element={<OpportunityWizard />} />
    </Routes>
  );
};

export default OpportunityWizardPage; 